import { TYPE_PROMOTION } from 'BannerPromotions/enums';

type OrderShowModalReturn = {
  id: number;
  modal: string;
};

export const orderShowModal: OrderShowModalReturn[] = [
  {
    id: 1,
    modal: TYPE_PROMOTION.INCIDENTES_RS,
  },
  {
    id: 2,
    modal: TYPE_PROMOTION.AVISO_MFA,
  },
  {
    id: 3,
    modal: TYPE_PROMOTION.NPS,
  },
  {
    id: 4,
    modal: TYPE_PROMOTION.PESQUISA_USABILIDADE,
  },
  {
    id: 5,
    modal: TYPE_PROMOTION.REFUEL,
  },
  {
    id: 6,
    modal: TYPE_PROMOTION.UPDATEPROFILE,
  },
  {
    id: 7,
    modal: TYPE_PROMOTION.AVISO_PIX,
  },
];
